import Grid from '@mui/material/Grid2'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

const Attribute = ({ icon, text }) => {
  return (
    <Grid size={{ xs: 12, md: 6 }}>
      <Stack spacing={2} direction="row" alignItems="center">
        {icon}
        <Typography sx={{ flex: 1 }} variant="subtitle2">
          {text}
        </Typography>
      </Stack>
    </Grid>
  )
}

export default Attribute
